import React from "react";

import FolderIcon from "@mui/icons-material/Folder";
import { Box, Breadcrumbs, Link, Paper, Stack } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import { Files, FilesType } from "../../services/api/files";
import { getRelativeTime } from "../../services/utils/dateTime";
import { formatBytes } from "../../services/utils/misc";

const FolderLink: React.FC<{ path: string; onClick: (path: string) => void }> = ({ path, onClick }) => {
  const parts = path.split("/");
  return (
    <Link data-path={path} onClick={() => onClick(path)} sx={{ cursor: "pointer" }} underline="hover">
      <Stack direction="row">
        <FolderIcon sx={{ marginRight: "4px" }} />
        <Typography>{parts[parts.length - 2]}</Typography>
      </Stack>
    </Link>
  );
};

const FileLink: React.FC<{ path: string }> = ({ path }) => {
  const handleClick = async () => {
    const signedURL = await Files.makeSignerURL(path);
    window.open(signedURL, "_blank");
  };
  return (
    <Link data-path={path} onClick={handleClick} sx={{ cursor: "pointer" }} underline="hover">
      {path.split("/").pop()}
    </Link>
  );
};

const JobFiles: React.FC<{ files: FilesType; path: string; setPath: (path: string) => void }> = ({
  files,
  path,
  setPath,
}) => {
  const pathParts = path.split("/");
  const breadcrumbs = pathParts.map((subPath, index) => {
    if (index === 0) return <Typography key={index}> {subPath} </Typography>;
    return (
      <Link
        underline="hover"
        key={index}
        sx={{ cursor: "pointer" }}
        onClick={() => setPath(pathParts.slice(0, index + 1).join("/") + "/")}
      >
        {subPath}
      </Link>
    );
  });

  return (
    <Box>
      <Typography variant="h5">Files</Typography>
      <Breadcrumbs separator="/">{breadcrumbs}</Breadcrumbs>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Size</TableCell>
              <TableCell align="right">Modified</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {files.folders?.map((folder, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  <FolderLink path={folder} key={index} onClick={setPath} />
                </TableCell>
              </TableRow>
            ))}
            {files.files?.map((file, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  <FileLink path={file.name} />
                </TableCell>
                <TableCell align="right">{formatBytes(file.size)}</TableCell>
                <TableCell align="right">{getRelativeTime(file.last_modified)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default JobFiles;
